module.exports = __webpack_public_path__ + "img/new_elin_download.d00cbdc2.png";